import { TransformerSet } from '../../../contexts/RequestsContext/constants';
import { Envelope } from '../../../types';
import { ConstructGet } from '../../types/ConstructGet';
import { SIGNATURE_BASE_PATH } from '../constants/signatureBasePath';

export const previewEnvelope = (
  constructGet: ConstructGet,
  envelope: Envelope,
): Promise<Blob | undefined> =>
  constructGet<Blob>(
    `${SIGNATURE_BASE_PATH}/envelope/${envelope.id}/preview`,
    { responseType: 'blob' },
    { transformerSet: TransformerSet.PreserveKeys },
  );
